// extracted by mini-css-extract-plugin
module.exports = {"Button":"B_sN x_sN x_sw h_fm h_fB h_fq h_hc","full":"B_tw h_dm h_dx","width100":"B_dm h_dm","design3Pos":"B_tx h_dR"};